import { Component } from '@theme/component';
import { StandardEvents } from '@shopify/events';

/**
 * A custom element that displays a product's part number (SKU) and keeps it
 * in sync with the selected variant, mirroring how <product-price> updates.
 */
class ProductPartNumber extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  /**
   * @param {CustomEvent & { promise?: Promise<any> }} event
   */
  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
    if (!event.promise) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;

        const newPartNumber = detail.html.querySelector(
          `product-part-number[data-block-id="${this.dataset.blockId}"]`
        );

        // Leave the element as-is if no match comes back (don't delete it — a later
        // variant switch needs it to still be here to update into).
        if (!newPartNumber) return;

        this.innerHTML = newPartNumber.innerHTML;

        if (newPartNumber.hasAttribute('hidden')) {
          this.setAttribute('hidden', '');
        } else {
          this.removeAttribute('hidden');
        }
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[product-part-number] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('product-part-number')) {
  customElements.define('product-part-number', ProductPartNumber);
}
